/**
 * ユーザ情報を扱うサービス
 */

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AsyncSubject, Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { User } from '../../domains';

@Injectable()
export class MeService {
  readonly #http = inject(HttpClient);

  static readonly meUrl = `${environment.classi_api_url}/me`;
  private user$: Observable<User> | null = null;

  /**
   * GET
   * @param {boolean} isForced - ユーザー情報を強制再取得するか否か
   * @returns {Observable<User>}
   */
  getMe(isForced = false): Observable<User> {
    if (this.user$ && !isForced) {
      return this.user$;
    }

    return (this.user$ = this.#http.get<User>(MeService.meUrl).pipe(
      share({
        connector: () => new AsyncSubject(),
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: false,
      }),
    ));
  }
}
